(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["knn-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  /* ----------------------------------------------------------------
     Purchase type toggle — Subscribe & Save / Buy Once
     Updates price display and the active variant for ATC.
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-product-card]').forEach(function (card) {
    var radios = card.querySelectorAll('.knn-product-card__radio-input');

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateCardPurchaseType(card, this.value);
      });
    });

    /* Homepage quick add always uses the one-bottle, one-time variant. Other card
       instances keep their existing Subscribe & Save default. */
    var atcBtn = card.querySelector('[data-atc-btn]');
    if (atcBtn) {
      if (card.dataset.forceOnetime === 'true' && card.dataset.onetimeVariant) {
        atcBtn.dataset.currentVariant = card.dataset.onetimeVariant;
        atcBtn.dataset.currentPlan = '';
      } else if (card.dataset.subVariant) {
        atcBtn.dataset.currentVariant = card.dataset.subVariant;
        atcBtn.dataset.currentPlan = card.dataset.subPlan || '';
      }
    }
  });

  function updateCardPurchaseType(card, type) {
    var priceEl   = card.querySelector('[data-price]');
    var compareEl = card.querySelector('[data-compare]');
    var atcBtn    = card.querySelector('[data-atc-btn]');

    var newPrice;
    var newCompare;
    var newVariantId;
    var newPlanId;

    if (type === 'subscribe') {
      newPrice     = card.dataset.subPrice;
      newCompare   = card.dataset.subCompare;
      newVariantId = card.dataset.subVariant;
      newPlanId    = card.dataset.subPlan || '';
    } else {
      newPrice     = card.dataset.onetimePrice;
      newCompare   = card.dataset.onetimeCompare;
      newVariantId = card.dataset.onetimeVariant;
      newPlanId    = '';   /* Buy Once never carries a plan. */
    }

    if (priceEl && newPrice) priceEl.textContent = newPrice;

    if (compareEl) {
      if (newCompare) {
        compareEl.textContent = newCompare;
        compareEl.classList.remove('knn-product-card__price-compare--hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('knn-product-card__price-compare--hidden');
      }
    }

    if (atcBtn && newVariantId) {
      atcBtn.dataset.currentVariant = newVariantId;
      atcBtn.dataset.currentPlan = newPlanId;
    }
  }

  /* ----------------------------------------------------------------
     Add to Cart
  ---------------------------------------------------------------- */
  document.querySelectorAll('[data-knn-product-card] [data-atc-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var variantId = this.dataset.currentVariant;
      if (!variantId) return;
      addToCart(parseInt(variantId, 10), this, this.dataset.currentPlan);
    });
  });

  function addToCart(variantId, btn, planId) {
    var addText     = btn.dataset.addText     || btn.textContent;
    var loadingText = btn.dataset.loadingText || '...';

    btn.disabled    = true;
    btn.textContent = loadingText;

    var item = { id: variantId, quantity: 1 };
    /* Attach the Recharge plan on Subscribe & Save. Omitted when blank — a falsy
       selling_plan makes Shopify reject the add. */
    if (planId) item.selling_plan = parseInt(planId, 10);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    })
    .then(function (r) {
      if (!r.ok) {
        return r.json().then(function (e) {
          throw new Error(e.description || 'Could not add item to cart.');
        });
      }
      return r.json();
    })
    .then(function () {
      /* Hand off to the KNN mini cart: it refreshes its body, opens, and syncs the
         header cart count. No page reload. */
      document.dispatchEvent(new CustomEvent('knn:cart:added', { bubbles: true }));
    })
    .catch(function (err) {
      /* eslint-disable no-console */
      console.error('[knn-product-card] add to cart error:', err.message);
      window.alert(err.message);
    })
    .finally(function () {
      btn.disabled    = false;
      btn.textContent = addText;
    });
  }

})();
  } catch(e) { console.error(e); }
})();

})();
